"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const shared_module_1 = require("../common/shared.module");
const angular_hybrid_1 = require("@uirouter/angular-hybrid");
const customer_care_states_1 = require("./customer-care.states");
const toggle_feature_flags_component_1 = require("./toggleFeatureFlags/toggle-feature-flags.component");
const i0 = require("@angular/core");
const i1 = require("@uirouter/angular-hybrid");
class CustomerCareModule {
}
exports.CustomerCareModule = CustomerCareModule;
CustomerCareModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomerCareModule });
CustomerCareModule.ɵinj = i0.ɵɵdefineInjector({ factory: function CustomerCareModule_Factory(t) { return new (t || CustomerCareModule)(); }, providers: [], imports: [[
            shared_module_1.SharedModule,
            angular_hybrid_1.UIRouterUpgradeModule.forChild({ states: customer_care_states_1.states })
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomerCareModule, { declarations: [toggle_feature_flags_component_1.ToggleFeatureFlagsComponent], imports: [shared_module_1.SharedModule, i1.UIRouterUpgradeModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CustomerCareModule, [{
        type: core_1.NgModule,
        args: [{
                imports: [
                    shared_module_1.SharedModule,
                    angular_hybrid_1.UIRouterUpgradeModule.forChild({ states: customer_care_states_1.states })
                ],
                providers: [],
                declarations: [
                    toggle_feature_flags_component_1.ToggleFeatureFlagsComponent
                ]
            }]
    }], null, null); })();
